import { useRef } from "react";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useOutsideClicked from "./useOutsideClicked";
import { FocusScope } from "@react-aria/focus";
import useMobileScreen from "./useMobileScreen";
import { useDispatch, useSelector } from "react-redux";
import { setWorkers } from "./Redux/companyReducer";


function DropdownCheckbox({ allWorkers, closeDropdown, dropdownButtonRef }) {
    const wrapperRef = useRef(null);
    const [workersFiltered, setWorkersFiltered] = useState([])
    const [userInput, setUserInput] = useState("")
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const workers = useSelector((state) => state.company.workers)
    const itemsCount = useSelector((state) => state.cart.itemCount)

    useMobileScreen()
    useOutsideClicked(wrapperRef, dropdownButtonRef, closeDropdown);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const handleClose = (e) => { if (e.keyCode === 13) { closeDropdown() } }
    const handleEsc = (e) => { if (e.keyCode === 27) { closeDropdown() } }

    useEffect(() => {
        if (userInput.trim()) {
            setWorkersFiltered(allWorkers.filter(worker =>
                worker.workerFirstName.includes(userInput.trim()) || worker.workerLastName.includes(userInput.trim())))
        } else {
            setWorkersFiltered(allWorkers)
        }
    }, [userInput])

    const handleSelect = (event, worker) => {
        if (!worker) {
            if (!event.target.checked) {
                dispatch(setWorkers([]))
            } else {
                dispatch(setWorkers(workersFiltered))
            }
        } else {
            if (!event.target.checked) {
                dispatch(setWorkers(workers.filter((w) => w.companyWorkerId !== worker.companyWorkerId)))
            } else {
                dispatch(setWorkers([...workers, worker]))
            }
        }
    }

    const isChecked = (worker) => {
        return workers.some((w) => w.companyWorkerId === worker.companyWorkerId)
    }

    const isMaxAmount = (worker) => {
        return !isChecked(worker) && workers && workers.length === itemsCount
    }

    return (
        <>
            {
                useMobileScreen() ?
                    <div role="dialog" ref={wrapperRef} className="dropdown-workers" onKeyDown={e => handleEsc(e)}>
                        <div className="d-flex justify-content-between dropdown-title">
                            <span
                                role="heading"
                                aria-label={`${t("choose")} ${itemsCount} ${t("recipients")} ${t("fromTheList")}`}
                            >
                                {t("choose")} {itemsCount} {t("recipients")} {t("fromTheList")}
                            </span>
                            <div aria-label={t("close")} className="close-btn" role="button" onKeyDown={e => handleClose(e)} onClick={closeDropdown}>
                                <span>✖</span>
                            </div>
                        </div>
                        <h6 aria-label={`${t("youChose")} ${workers.length} ${t("recipients")}`} className="mb-3">{t("youChose") + " " + workers.length + " " + t("recipients")}</h6>

                        <div className="search-worker">
                            <i> <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13 13L19 19M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg></i>
                            <input type="text" aria-label={t("searchRecipient")} onChange={e => setUserInput(e.target.value)} />
                        </div>
                        <Form>
                            <div className="checkbox-worker">
                                <input type="checkbox" id='all' checked={workersFiltered.length == workers.length} onChange={(event) => handleSelect(event, null)} />
                                <label htmlFor='all'>{t("SelectAll")}</label>
                            </div>
                            {
                                workersFiltered.map((worker) => {
                                    return <div className="checkbox-worker" key={worker.companyWorkerId}>
                                        <input type="checkbox" id={worker.companyWorkerId} checked={isChecked(worker)} disabled={isMaxAmount(worker)} onChange={(event) => handleSelect(event, worker)} />
                                        <label htmlFor={worker.companyWorkerId}>{worker.workerFirstName} {worker.workerLastName}</label>
                                    </div>
                                })
                            }
                        </Form>
                    </div>
                    :
                    <FocusScope contain restoreFocus autoFocus>
                        <div role="dialog" ref={wrapperRef} className="dropdown-workers" onKeyDown={e => handleEsc(e)}>
                            <div className="d-flex justify-content-between dropdown-title">
                                <span
                                    role="heading"
                                    aria-label={`${t("choose")} ${itemsCount} ${t("recipients")} ${t("fromTheList")}`}
                                >
                                    {t("choose")} {itemsCount} {t("recipients")} {t("fromTheList")}
                                </span>
                                {/* <div aria-label={t("close")} className="close-btn" role="button" onKeyDown={e => handleClose(e)} onClick={closeDropdown}>
                                        <span>✖</span>
                                    </div> */}
                            </div>
                            <h6 aria-label={`${t("youChose")} ${workers.length} ${t("recipients")}`} className="mb-3">{t("youChose") + " " + workers.length + " " + t("recipients")}</h6>

                            <div className="search-worker">
                                <i> <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M13 13L19 19M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg></i>
                                <input type="text" aria-label={t("searchRecipient")} onChange={e => setUserInput(e.target.value)} />
                            </div>
                            <Form>
                                <div className="checkbox-worker">
                                    <input type="checkbox" id='all' checked={workersFiltered.length == workers.length} onChange={(event) => handleSelect(event, null)} />
                                    <label htmlFor='all'>{t('SelectAll')}</label>
                                </div>
                                {
                                    workersFiltered.map((worker) => {
                                        return <div className="checkbox-worker" key={worker.companyWorkerId}>
                                            <input type="checkbox" id={worker.companyWorkerId} checked={isChecked(worker)} disabled={isMaxAmount(worker)} onChange={(event) => handleSelect(event, worker)} />
                                            <label htmlFor={worker.companyWorkerId}>{worker.workerFirstName} {worker.workerLastName}</label>
                                        </div>
                                    })
                                }
                            </Form>
                        </div>
                    </FocusScope>
            }
        </>
    );
}

export default DropdownCheckbox;
